import React, { useState, useEffect } from "react";
import { upsertPost } from "./utils/storage";

const NewsForm = ({ language = "en", onAdd, editItem, setEditItem }) => {
  const isAdmin = localStorage.getItem("isAdmin") === "true";
const [errors, setErrors] = useState({});

  // Default form structure
 const defaultForm = {
  id: "",
  title: { en: "", ar: "" },
  desc: { en: "", ar: "" },
  img: "",
  thumb: "",
  date: new Date().toISOString().slice(0, 10),
  time: new Date().toTimeString().slice(0, 5),
  category: "news",
  tags: "",
  author: "Admin",
  content: { en: [], ar: [] },
};


  useEffect(() => {
    setInputLang(language);
  }, [language]);

  // Hook for managing form state
  const [form, setForm] = useState(defaultForm);
  const [previewMain, setPreviewMain] = useState(null);
  const [previewThumb, setPreviewThumb] = useState(null);

  const [inputLang, setInputLang] = useState("en"); // Language for title/desc input
  const [contentLang, setContentLang] = useState("en"); // Language for content

  // Edit mode loading
  useEffect(() => {
    if (editItem) {
      setForm({
        ...defaultForm,
        ...editItem,
        title: { en: "", ar: "", ...(editItem.title || {}) },
        desc: { en: "", ar: "", ...(editItem.desc || {}) },
        content: {
          en: editItem.content?.en || [],
          ar: editItem.content?.ar || [],
        },
      });

      setPreviewMain(editItem.img || null);
      setPreviewThumb(editItem.thumb || null);
    } else {
      setForm(defaultForm);
      setPreviewMain(null);
      setPreviewThumb(null);
    }
  }, [editItem]);

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // Handle language-specific input changes (for title, desc)
  const handleLangInput = (section, value) => {
    setForm((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [inputLang]: value,
      },
    }));
  };

  // File handling for images
  const cleanFileName = (file) => file.name.replace(/\s+/g, "_");

  const handleMainImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const clean = cleanFileName(file);

    setForm((prev) => ({ ...prev, img: `/images/${clean}` }));
    setPreviewMain(URL.createObjectURL(file));

    alert(
  language === "ar"
    ? `⚠️ يرجى نسخ الملف "${clean}" يدويًا إلى مجلد public/images`
    : `⚠️ Copy "${clean}" manually into /public/images`
);

  };

  const handleThumbImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const clean = cleanFileName(file);

    // setForm((prev) => ({ ...prev, thumb: `/images/${clean}` }));
    setPreviewThumb(URL.createObjectURL(file));

    alert(`⚠️ Copy "${clean}" manually into /public/images`);
  };

  // Content Block Builder for adding paragraphs and images
  const addParagraph = () => {
    setForm((prev) => ({
      ...prev,
      content: {
        ...prev.content,
        [contentLang]: [
          ...prev.content[contentLang],
          { type: "paragraph", text: "" },
        ],
      },
    }));
  };

  const addImageBlock = () => {
    setForm((prev) => ({
      ...prev,
      content: {
        ...prev.content,
        [contentLang]: [
          ...prev.content[contentLang],
          { type: "image", src: "" },
        ],
      },
    }));
  };

  const updateParagraph = (value, index) => {
    const updated = [...form.content[contentLang]];
    updated[index].text = value;

    setForm((prev) => ({
      ...prev,
      content: { ...prev.content, [contentLang]: updated },
    }));
  };

  const updateImageBlock = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const clean = cleanFileName(file);

    const updated = [...form.content[contentLang]];
    updated[index] = { type: "image", src: `/images/${clean}` };

    setForm((prev) => ({
      ...prev,
      content: { ...prev.content, [contentLang]: updated },
    }));

    alert(`⚠️ Copy "${clean}" manually into /public/images`);
  };

  // Submit handler for form
const submitPost = (e) => {
  e.preventDefault();

  const newErrors = {};

  if (!form.title.en.trim()) newErrors.title_en = true;
  if (!form.title.ar.trim()) newErrors.title_ar = true;

  if (!form.desc.en.trim()) newErrors.desc_en = true;
  if (!form.desc.ar.trim()) newErrors.desc_ar = true;

  if (!form.img) newErrors.img = true;

  if (!form.content.en.length) newErrors.content_en = true;
  if (!form.content.ar.length) newErrors.content_ar = true;

  setErrors(newErrors);

  if (Object.keys(newErrors).length) return;

  const payload = {
    ...form,
    id: form.id || Date.now(),
    tags: form.tags ? form.tags.split(",").map((t) => t.trim()) : [],
  };

  const updatedDb = upsertPost(payload, form.category, language);
  onAdd?.(updatedDb);

  setEditItem(null);
  setForm(defaultForm);
  setPreviewMain(null);
  setPreviewThumb(null);
  setErrors({});
};



  // Reject non-admin view
  if (!isAdmin) return null;

  return (
    <div className="p-3">
      <h5 className="mb-3">
        {editItem
          ? language === "ar"
            ? "تعديل المنشور"
            : "Edit Post"
          : language === "ar"
          ? "إضافة منشور"
          : "Add Post"}
      </h5>

      <form onSubmit={submitPost}>
        {/* Category Dropdown */}
        <select
          className="form-control mb-2 select-arrow"
          name="category"
          value={form.category}
          onChange={handleChange}
        >
          <option value="news">{language === "ar" ? "الأخبار" : "News"}</option>
          <option value="insights">
            {language === "ar" ? "التحليلات" : "Insights"}
          </option>
        </select>
        {/* Language Switch */}
        <div className="btn-group mb-3">
          <button
            type="button"
            className={`btn ${
              inputLang === "en" ? "newsformbtn" : "newsformbtn-border"
            }`}
            onClick={() => setInputLang("en")}
          >
            {language === "ar" ? "المدخلات الإنجليزية" : "English Inputs"}
          </button>

          <button
            type="button"
            className={`btn ${
              inputLang === "ar" ? "newsformbtn" : "newsformbtn-border"
            }`}
            onClick={() => setInputLang("ar")}
          >
            {language === "ar" ? "المدخلات العربية" : "Arabic Inputs"}
          </button>
        </div>
        {/* Title */}
        <input
          className="form-control mb-2"
          placeholder={inputLang === "ar" ? "عنوان المنشور" : "Post Title"}
          dir={inputLang === "ar" ? "rtl" : "ltr"}
          value={form.title[inputLang]}
          onChange={(e) => handleLangInput("title", e.target.value)}
        />
        {/* Description */}
        <textarea
          className="form-control mb-3"
          rows={2}
          placeholder={inputLang === "ar" ? "وصف مختصر" : "Short Description"}
          dir={inputLang === "ar" ? "rtl" : "ltr"}
          value={form.desc[inputLang]}
          onChange={(e) => handleLangInput("desc", e.target.value)}
        />
        {/* Main Image Upload */}
        <label className="form-label">
          {language === "ar" ? "الصورة الرئيسية" : "Main Image"}
        </label>
    
    <div className="custom-file-wrapper">
  <div className="file-hidden"  
  
  >
  <input
    type="file"
    id="mainImageInput"
    onChange={handleMainImage}
    style={{
      position: "absolute",
      width: "1px",
      height: "1px",
      opacity: 0,
      overflow: "hidden",
      zIndex: -1,
    }}
  />

  </div>

  <div className="d-flex align-items-center">
    <label htmlFor="mainImageInput" 
    style={{
    display: "flex",
  padding: "10px 18px",
  background: "#6c4bff",
  color: "#fff",
  borderRadius: "6px",
  cursor: "pointer",
  fontSize: "14px",
  minWidth: "110px",
  texAlign: "center",
  margin:"0 10px 0 0",
    }}
  >
    {language === "ar" ? "اختر ملف" : "Choose File"}
  </label>

  <span className="file-name">
    {previewMain
      ? language === "ar"
        ? "تم اختيار ملف"
        : "File selected"
      : language === "ar"
      ? "لم يتم اختيار ملف"
      : "No file chosen"}
  </span>
  </div>
</div>

       
        {/* Thumbnail */}{" "}
        <label className="mt-3">
          {" "}
          {language === "ar" ? "الصورة المصغرة" : "Thumbnail"}{" "}
        </label>{" "}
          <div className="custom-file-wrapper">
  <div className="file-hidden">
  
   
<input
    type="file"
    id="thumbImageInput"
  onChange={handleThumbImage}
    style={{
      position: "absolute",
      width: "1px",
      height: "1px",
      opacity: 0,
      overflow: "hidden",
      zIndex: -1,
    }}
  />

  </div>
<div className="d-flex align-items-center mx-3">
 <label htmlFor="thumbImageInput" 
 
  style={{
    display: "flex",
  padding: "10px 18px",
  background: "#6c4bff",
  color: "#fff",
  borderRadius: "6px",
  cursor: "pointer",
  fontSize: "14px",
  minWidth: "110px",
  texAlign: "center",
  margin:"0 10px 0 0",
    }}

 >
  {language === "ar" ? "اختر ملف" : "Choose File"}
</label>

<span className="file-name">
  {previewThumb
    ? language === "ar"
      ? "تم اختيار ملف"
      : "File selected"
    : language === "ar"
    ? "لم يتم اختيار ملف"
    : "No file chosen"}
</span>
</div>
</div>
     
       
        {/* Date / Time / Tags */}
        <div className="row mt-3">
          <div className="col-md-4">
            <input
              type="date"
              name="date"
              className="form-control"
              value={form.date}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-4">
            <input
              type="time"
              name="time"
              className="form-control"
              value={form.time}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-4">
            <input
              name="tags"
              className="form-control"
              placeholder={language === "ar" ? "وسوم..." : "Tags..."}
              value={form.tags}
              onChange={handleChange}
            />
          </div>
        </div>
        {/* Content Builder */}
        <hr className="my-4" />
        <h6>{language === "ar" ? "منشئ المحتوى" : "Long Content Builder"}</h6>
        <div className="btn-group mb-3">
          <button
            type="button"
            className={`btn ${
              contentLang === "en" ? "newsformbtn" : "newsformbtn-border"
            }`}
            onClick={() => setContentLang("en")}
          >
            {language === "ar" ? "المحتوى الإنجليزي" : "English Content"}
          </button>

          <button
            type="button"
            className={`btn ${
              contentLang === "ar" ? "newsformbtn" : "newsformbtn-border"
            }`}
            onClick={() => setContentLang("ar")}
          >
            {language === "ar" ? "المحتوى العربي" : "Arabic Content"}
          </button>
        </div>
        {form.content[contentLang].map((block, i) => (
          <div key={i} className="border p-2 bg-light rounded mb-2">
            {block.type === "paragraph" ? (
              <textarea
                className="newsformbtn-border"
                rows={3}
                dir={contentLang === "ar" ? "rtl" : "ltr"}
                placeholder={
                  contentLang === "ar" ? "نص الفقرة..." : "Paragraph text..."
                }
                value={block.text}
                onChange={(e) => updateParagraph(e.target.value, i)}
              />
            ) : (
              <>
                <label>{language === "ar" ? "رفع صورة" : "Upload Image"}</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => updateImageBlock(e, i)}
                />
              </>
            )}
          </div>
        ))}
        <br />
        {/* Action Buttons */}
        <button
          type="button"
          className="newsformbtn-border rounded p-2 mx-2"
          onClick={addParagraph}
        >
          {language === "ar" ? "+ إضافة فقرة" : "+ Add Paragraph"}
        </button>
        <button
          type="button"
          className="newsformbtn-border rounded p-2 mx-2"
          onClick={addImageBlock}
        >
          {language === "ar" ? "+ إضافة صورة" : "+ Add Image"}
        </button>
        {/* Save */}
        <div className="mt-4">
          <button className="explore-btn px-3">
            {language === "ar" ? "حفظ" : "Save Post"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewsForm;
